var codeblock_default = {
  "blockStyleSpacing": "TyuDC",
  "codeBlock": "_530l1 TyuDC",
  "renderedInTable": "Qxck2"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
